const variables = {
    //本機開發環境   
    //API_URL: "https://localhost:44321/api/",

    //正式環境
    API_URL: "/COMPALEMPAPI/api/",
  };
  
  export default variables;